import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ManagedStockGroupsSearchFilterQuery } from "models/filters/managedStockGroups/ManagedStockGroupsSearchFilterQuery";
import { ManagedStockGroupsApi } from "apis/ManagedStockGroupsApi";
import { ManagedStocksApi } from "apis/ManagedStocksApi";
import { ManagedStockSearchFilterQuery } from "models/filters/managedStocks/ManagedStockSearchFilterQuery";
import { ManagedStockGroup } from "models/dbModels/managedStockGroups/ManagedStockGroup";
import { BulkEditManagedStock } from "models/daoModels/managedStock/BulkEditManagedStock";

export const getStockGroups = createAsyncThunk("stockGroupsSlice/getStockGroups", async (params?: ManagedStockGroupsSearchFilterQuery) => {
    const response = await ManagedStockGroupsApi.Search(params ?? {});
    return response.data;
});

export const getStockGroupsTable = createAsyncThunk("stocksSlice/getStockGroupsTable", async (params: ManagedStockSearchFilterQuery) => {
    params = { ...params, offset: params.offset || 0, limit: params.limit || 100 };
    const response = await ManagedStocksApi.OptimsedSearch(params);
    return response.data;
});

export const getStockGroupDetails = createAsyncThunk("stockGroupsSlice/getStockGroupDetails", async (stockGroupId: number) => {
    const response = await ManagedStockGroupsApi.Search({ ids: [stockGroupId] });
    return response.data;
});

export const createStockGroup = createAsyncThunk("stockGroupsSlice/createStockGroup", async (stockGroup: ManagedStockGroup) => {
    const response = await ManagedStockGroupsApi.Add([stockGroup]);
    return response.data;
});

export const updateStockGroup = createAsyncThunk("stockGroupsSlice/updateStockGroup", async (stockGroup: ManagedStockGroup) => {
    const response = await ManagedStockGroupsApi.Update([stockGroup]);
    return response.data;
});

export const deleteStockGroup = createAsyncThunk("stockGroupsSlice/deleteStockGroup", async (stockGroupsId: number[]) => {
    const response = await ManagedStockGroupsApi.Delete({ selectedIds: stockGroupsId });
    return response.data;
});

export const importStockToStockGroup = createAsyncThunk("stockGroupsSlice/importStockToStockGroup", async (params: BulkEditManagedStock) => {
    const response = await ManagedStocksApi.BulkUpdate(params);
    return response.data;
});

type InitialStateType = {
    id: number;
    name: string;
    locked: boolean;
    modelId: string;
    selectedRows: { position: number, id: number }[][];
    loading: boolean;
    stockTable: any[];
    stockPopup: boolean;
    error: string;
    keyword: string;
    totalRows: number;
    totalPages: number;
    pageIndex: number;
    pageSize: number;
    table: ManagedStockGroup[]
};

const initialState: InitialStateType = {
    id: 0,
    name: "",
    locked: false,
    modelId: '',
    selectedRows: [],
    loading: false,
    stockTable: [],
    stockPopup: false,
    error: "",
    keyword: "",
    totalRows: 0,
    totalPages: 0,
    pageIndex: 0,
    pageSize: 100,
    table: [],
}

const stockGroupsSlice = createSlice({
    name: "stockGroupsSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        updateStockGroupField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        cleanStockGroupDetails: (state) => {
            return {
                ...state,
                ...initialState,
            }
        },
        addSelectedRows: (state, action) => {
            // @ts-ignore
           state.selectedRows[action.payload.index] = action.payload.rows;                 
        },
        addAGGridSelectedRows: (state, action) => {
            return {
                ...state,
                selectedRows: action.payload
            };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getStockGroups.fulfilled, (state, action) => {
            state.table = action.payload.data ?? [];
            state.loading = false;
            state.totalRows = action.payload.totalRows ? action.payload.totalRows : 0;
        });
        builder.addCase(getStockGroups.pending, (state) => {
            state.loading = true;
            state.table = [];
            state.error = "";
        });
        builder.addCase(getStockGroups.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || "";
        });
        builder.addCase(getStockGroupDetails.fulfilled, (state, action) => {
            return {
                ...state,
                ...action.payload.data[0],
            };
        });
        builder.addCase(getStockGroupsTable.fulfilled, (state, action) => {
            state.stockTable = action.payload.data ? action.payload.data : [];
            state.totalRows = action.payload.totalRows;
            state.loading = false;
        });
        builder.addCase(getStockGroupsTable.pending, (state, action) => {
            state.loading = true;
            state.stockTable = [];
            state.error = "";
        });
        builder.addCase(getStockGroupsTable.rejected, (state, action) => {
            state.loading = false;
            state.stockTable = [];
            state.error = action.error.message || "";
        });
        builder.addCase(createStockGroup.fulfilled, (state, action) => {
            console.log(action);
        });
    }
});

export const { updateStockGroupField, addSelectedRows, cleanStockGroupDetails, addAGGridSelectedRows } = stockGroupsSlice.actions;

export default stockGroupsSlice.reducer;
